import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function RemoveOrderSupplierDialog({ supplierName, open, onCancel, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="remove-order-supplier-title"
      PaperProps={{ sx: { borderRadius: "20px", maxWidth: 450 } }}
    >
      <DialogTitle id="remove-order-supplier-title" sx={{ color: "primary.900", fontWeight: 900 }}>
        Quitar proveedor
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "neutral.700", fontSize: 14, fontWeight: 600 }}>
          Se eliminarán los ítems y valores cargados para {supplierName}. Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button type="button" onClick={onCancel} sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}>
          Seguir editando
        </Button>
        <Button type="button" variant="contained" color="error" onClick={onConfirm} sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}>
          Quitar proveedor
        </Button>
      </DialogActions>
    </Dialog>
  );
}
